import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { Link, useNavigate } from "react-router-dom";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Vehicle_sale_and_scrap = () => {
  useAuthRedirect();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const storedBranch = localStorage.getItem("branch");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();


  const canView  = hasPermission("For sale-and-scrap", "view");
      const canEntry = hasPermission("For sale-and-scrap", "entry");
    
    
  
      
  // Fetch data based on selected branch
  useEffect(() => {
    setLoading(true);
    axios
      .get(`https://rfs2.infraconsoft.net.in/api/sale_and_scrap_list?branch_code=${storedBranch}`)
      .then((response) => {
        setData(response.data.saleReport);
        setFilteredData(response.data.saleReport);
      })
      .catch((error) => {
        console.error("Error fetching saleReport:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [storedBranch]);

  // Handle page change
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate indexes for pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle search filter
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    const filtered = data.filter((item) => {
      return (
        (item.branch_code && item.branch_code.toLowerCase().includes(e.target.value.toLowerCase())) ||
        (item.vehicle_code && item.vehicle_code.toLowerCase().includes(e.target.value.toLowerCase())) ||
        (item.vehicle_name && item.vehicle_name.toLowerCase().includes(e.target.value.toLowerCase()))
      );
    });
    setFilteredData(filtered);
    setCurrentPage(1);
  };

  // 🔹 Handle click for Sale OR Scrap (Check transfer first)
  // 🔹 Handle click for Sale OR Scrap (Check transfer first)
const handleSaleOrScrapClick = async (vehicle_code, SlNo, branch_code) => {
  try {
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const res = await axios.get(`https://rfs2.infraconsoft.net.in/api/check_transfer/${vehicle_code}`);
    console.log("✅ API Response:", res.data);

    Swal.close(); // ✅ close the loading popup as soon as response arrives

    if (res.data.count > 0) {
      Swal.fire({
        icon: "warning",
        title: "Transfer Pending",
        text: `Transfer is pending approval for another branch, you cannot sell or scrap this vehicle.`,
      });
    } else {
      navigate(`/vehicle_salescrap/${SlNo}`);
    }
  } catch (error) {
    Swal.close(); // ✅ also close if API fails
    console.error("❌ Error checking transfer:", error);
    Swal.fire("Error", "Something went wrong while checking transfer.", "error");
  }
};

 if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Vehicle SALE and SCRAP</h2>
          <div>
            <Time />
          </div>
        </section>

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by vehicleName"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Branch Code</th>
                <th>Vehicle Code</th>
                <th>Vehicle Name</th>
                <th>Vehicle Number</th>
                <th>Details</th>
                {canEntry && (
                <th>Sale OR Scrap</th>
                )}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="7" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{item.branch_code}</td>
                    <td>{item.vehicle_code}</td>
                    <td>{item.vehicle_name}</td>
                    <td>{item.vehicle_number}</td>
                    <td>
                      <Link to={`/vehicle_details_viewonly/${item.SlNo}`}>Details</Link>
                    </td>
                    {canEntry && (
                    <td>
                      <span
                        onClick={() =>
                          handleSaleOrScrapClick(item.vehicle_code, item.SlNo, item.branch_code)
                        }
                        style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
                      >
                        Sale OR Scrap
                      </span>
                    </td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          <button onClick={() => paginate(1)} className={currentPage === 1 ? "active" : ""}>
            1
          </button>

          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.max(0, Math.ceil(filteredData.length / itemsPerPage) - 1)))]
              .map((_, index) => {
                const pageNumber = currentPage + index;
                if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                  return (
                    <button
                      key={pageNumber}
                      onClick={() => paginate(pageNumber)}
                      className={currentPage === pageNumber ? "active" : ""}
                    >
                      {pageNumber}
                    </button>
                  );
                }
                return null;
              })}

          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Vehicle_sale_and_scrap;
